module.exports = __webpack_public_path__ + "static/fonts/barlowcondensed-thin-webfont.282f6ca.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/barlowcondensed-thin-webfont.eot
// module id = 116
// module chunks = 0